import * as Workflow from 'esri/widgets/Editor/Workflow';
import { Client } from './client';
import { WorkflowApplicationReportDataSet } from './report-data-set';
import { DepartmentAddress  } from './address';
import { get } from 'lodash';
import { DepartmentPhoneNumber } from './phone-number';

export class Department {
  id: string;
  name: string;
  clientId?: string;
  client: Client;
  description: string;
  headerText: string;
  iconUrl: string;
  workflows: Workflow[];
  isEnabled: boolean;
  requireDocumentReview: boolean;
  applicationGridDataSet?: WorkflowApplicationReportDataSet;
  applicationGridDataSetId?: string;
  deletedOnString?: string;
  deletedBy?: string;
  createdBy: string;
  createdOnString: string;
  modifiedBy: string;
  modifiedOnString: string;
  inspectionGridColumnsJSON?: string;
  hasInspectionAppLicense?: boolean;
  addressId?: string;
  address: DepartmentAddress;
  phoneNumberId?: string;
  phoneNumber?: DepartmentPhoneNumber;
  faxNumberId?: string;
  faxNumber?: DepartmentPhoneNumber;

  constructor() {
    this.workflows = [];
    this.isEnabled = false;
    this.requireDocumentReview = false;
  }
}
